import { Length } from './Units';
import { Background, Lights, Environment } from './Colours';
import cached_reactive from '@phi/cached-reactive';
import { Store } from '@phi/util/store';

export type Settings = typeof defaults;

export const defaults = {
    /** indicates that we should use the old, inset design */
    inset: false,

    /** indicates that the tutorial should be skipped */
    skip_tutorial: undefined as undefined | string,

    /** length units used, like centimetres or inches  */
    display_units: Length.cm as Length,

    /** indicates that button labels should be shown */
    labels: true,

    /** indicates that tooltips should be shown */
    tooltips: true,

    /** indicates that object insides should be coloured red */
    inside_red: true,

    /** sets the sensitivity of the zoom */
    zoom_speed: 0.04,

    /** indicates how many floating point decimals should be shown before being truncated */
    coordinate_decimals: 2,

    background: Background.black as Background,
    lights: Lights.regular as Lights,
    environment: Environment.bokeh as Environment,

    /** number of triangles used for the mesh approximation of surfaces */
    triangles: 1600,

    reference_transparent: true,

    /** indicates whether we should be saving backup versions of .phi files */
    save_backups: false,

    split_faces: false,
};

export default (store: Store) => cached_reactive(
    store,
    'settings',
    { ...defaults },
);
